import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, Content } from 'ionic-angular';
import { RcsKdDataServiceProvider } from '../../providers/rcs-kd-data-service/rcs-kd-data-service';
import { StackService } from '../../providers/odoo/stack.service';

@IonicPage()
@Component({
  selector: 'calender-month',
  templateUrl: 'calender-month.html'
})
export class CalenderMonthPage implements OnInit{

  @ViewChild(Content) content: Content;
  public show_searchbar: boolean
  //private job_filter:JobFilterPrototyp = new JobFilterPrototyp()
  public search_terms: Array<string>
  //private loading: Loading
  private all_jobs: Array<any>
  public sorted_jobs: Array<any>

  constructor(public nav_controller: NavController,
              private data_service: RcsKdDataServiceProvider,
              private stack: StackService
  ) {}

  ngOnInit(): void {}

  ionViewWillEnter(){
    this.search_terms = [];
    this.data_service.get_jobs().subscribe(
      result => {
        let jobs: any = result;
        this.all_jobs = jobs;
      },
      error => {},
      () => { this.search(); }
    )
  }

  public set_searchmode_mode(){
    if(this.show_searchbar){
      this.show_searchbar = false;
      this.content.resize();
    }else{
      this.show_searchbar = true;
      this.content.resize();
    }
  }

  public get_search_terms(search_terms){
    this.search_terms = search_terms;
    this.search();
  }

  public search(){
    if (this.search_terms.length > 0){
      this.search_jobs();
    }else{
      this.create_calender_dates(this.all_jobs);
    }
  }

  public search_jobs(){
    for(let term of this.search_terms){

      let results = []
      for (let job of this.all_jobs){
        const regex = new RegExp(term, 'i');
        if (job.name.match(regex) !== null || job.date_planned.match(regex) !== null || job.description.match(regex) !== null){
          results.push(job);
        }
      }
      this.create_calender_dates(results);
    }
  }

  public sort(jobs:Array<any>){
    let sorted_jobs = jobs.sort(function(a, b){
      if (a.name && b.name){
        if (a.name.toUpperCase() < b.name.toUpperCase()) { return 1 }
        return 0;
      }
    });
    return sorted_jobs;
  }

  public doRefresh(refresher) {
    setTimeout(() => {
      if (this.stack.getNetworkState()){
        this.data_service.sync_jobs().subscribe(
          flag_finish => {
            flag_finish.subscribe(
              data => {
                refresher.complete();
                this.nav_controller.setPages([{'page': 'CalenderMonthPage', 'params': {}}]);
              },
            )
          }
        )
      }
    }, 1000);
  }

  public go_to_edit_page(job:any):void{
    this.nav_controller.push('JobPage', { job: job, page: 'HomePage'});
  }

  private getDaysInMonth(month, year) {
       var date = new Date(year, month, 1);
       var days = [];
       while (date.getMonth() === month) {
          days.push(new Date(date));
          date.setDate(date.getDate() + 1);
       }
       return days;
  }

  public create_calender_dates(jobs){
    let dates = [];
    const date = new Date();
    dates = this.getDaysInMonth(date.getMonth(), date.getFullYear());

    this.sorted_jobs = [];

    for (let date of dates){
      let current_jobs = [];
      for (let job of jobs){
        if (new Date(job.date_planned).setHours(0,0,0,0) === date.setHours(0,0,0,0)){
          current_jobs.push(job);
        }
      }

      this.sorted_jobs.push(
        {'date': date, 'jobs': current_jobs}
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/calender-month/calender-month.ts